import links from "@/links/links";

export default {
  actions: {
    GET(agencyId, slug) {
      return this.get(links.TABLE_HEADER_GET(agencyId, slug), {
        dataTransformer: ({ data, headers }) => {
          var tableHeader = data["hydra:member"][0];
          // !!!: parse json values before inserting them into orm store NOTE: text type in DB, not json
          tableHeader.columns = JSON.parse(tableHeader.columns);
          tableHeader.settings = JSON.parse(tableHeader.settings);
          return tableHeader;
        },
      });
    },
    PUT(header) {
      var headerPut = JSON.parse(JSON.stringify(header));
      // !!!: stringify json header values before inserting them into DB NOTE: text type in DB, not json
      headerPut.columns = JSON.stringify(headerPut.columns);
      headerPut.settings = JSON.stringify(headerPut.settings);
      return this.put(links.TABLE_HEADER_PUT(headerPut.id), headerPut, {
        save: false,
      });
    },
  },
};
